import React, { useEffect } from "react";
import { Button, message, Space, Switch } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IApplySearch, IApplyParams, IApplyDetail, IApplyInsert, IApplyUpdata, IApplyDisable } from "../applyTypes"
import { useApplyModel } from "../applyModel"
import { DetailType } from "../../../../types/FmsEnums";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"
import moment, { Moment } from "moment";

const ApplyList = () => {
    const { dataSource, page, selectedRowKeys, selectedRow, loadData, setSelectedRowKeys, cutDisabled, setSelectedRow } = useApplyModel()
    const { addNav } = useNavModel()
    useEffect(() => {
        loadData()
    }, [])
    const columns: ColumnsType<IApplyDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '分支编码',
            dataIndex: 'branch',
        },
        {
            title: '数据版本号',
            dataIndex: 'ver',
        },
        {
            title: '应用编码',
            dataIndex: 'code',
        },
        {
            title: '应用名称',
            dataIndex: 'name',
        },
        {
            title: '应用类型',
            dataIndex: 'typeName',
        },
        {
            title: '应用地址',
            dataIndex: 'address',
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
        {
            title: '状态',
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    {/* checked={record.materialStatus == 0} */}
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        // onDisabled(record.id, checked);
                        cutDisabled(record, checked)
                    }} />
                </Space>
            ),

        }
    ];
    const onDetail = (type: string) => {
        const id = selectedRowKeys[0] as string //这里做类型转换

        switch (type) {
            case DetailType.add:
                return addNav("2-8-1", { id: "", mode: type })
            case DetailType.edit:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要编辑的数据" })
                return addNav("2-8-2", { id, mode: type });
            case DetailType.look:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("2-8-3", { id, mode: type });
            default:
                return false
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("edit")}
        >编辑</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("look")}
        >查看</Button> */}
    </>
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: IApplyDetail[]) {
            setSelectedRowKeys(selectedRowKeys)
            setSelectedRow(selectedRows)
        },
        selectedRowKeys
    }
    const onRow = (record: IApplyDetail) => {
        return {
            onClick: () => {
                if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                    setSelectedRowKeys([])
                    setSelectedRow([])
                } else {
                    setSelectedRowKeys([record.key as string])
                    setSelectedRow([{
                        ...record,
                        appUrl: typeof record.appUrl === "string" ? [record.appUrl] : []
                    }])
                }
            },
        }
    }
    return (
        <YhBox action={action}>
            <Table
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    ...rowSelection
                }}
                onRow={onRow}
                pagination={{
                    ...page,
                    position: ["bottomCenter"],
                    showTotal: () => `共${page.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}
export default ApplyList